export default "https://cdn-static.gokick.com/assets/29e4076df1e4180397d7539366c975103b08717a/images/tangerine-flavor.f6541269ddee78b301b9a4e8b180b6f6.png";